<template>
  <div class="absolute top-0 left-0 bottom-0 right-0">
    <div class="relative h-full">
      <div class="v-modal-bg" @click="onHideModelBg"></div>
      <div class="flex justify-center w-full h-full items-center">
        <div class="z-model bg-white p-5 box-shadow-bh">
          <slot> </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bh-model-card",

  data() {
    return {};
  },

  computed: {},

  mounted() {},

  methods: {
    onHideModelBg() {
      this.$emit("onHideModel", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.z-model {
  z-index: 777;
  border-radius: 20px;
}
</style>
